import Menubar from "./Menubar.component";

export default Menubar;
